/* tslint:disable */
/* eslint-disable */
/**
 * Spazious Backoffice API
 * Spazious private JSON:API v3 specification
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { GenericOrderReadAttributesUnfinishedTasksTypes } from './generic-order-read-attributes-unfinished-tasks-types';
/**
 * 
 * @export
 * @interface GenericOrderReadAttributes
 */
export interface GenericOrderReadAttributes {
    /**
     * 
     * @type {string}
     * @memberof GenericOrderReadAttributes
     */
    amount?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GenericOrderReadAttributes
     */
    attendees?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GenericOrderReadAttributes
     */
    channelType?: GenericOrderReadAttributesChannelTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof GenericOrderReadAttributes
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof GenericOrderReadAttributes
     */
    customerNotificationAt?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof GenericOrderReadAttributes
     */
    discount: string | null;
    /**
     * 
     * @type {string}
     * @memberof GenericOrderReadAttributes
     */
    endDate?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GenericOrderReadAttributes
     */
    isOverdueExceeded?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof GenericOrderReadAttributes
     */
    modificationAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof GenericOrderReadAttributes
     */
    name?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GenericOrderReadAttributes
     */
    nextStatuses?: Array<GenericOrderReadAttributesNextStatusesEnum>;
    /**
     * 
     * @type {string}
     * @memberof GenericOrderReadAttributes
     */
    orderReference?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericOrderReadAttributes
     */
    orderTracker?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericOrderReadAttributes
     */
    overdueDate?: string | null;
    /**
     * The probability of the order occurring as a percentage.
     * @type {string}
     * @memberof GenericOrderReadAttributes
     */
    probabilityConfirmation?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof GenericOrderReadAttributes
     */
    requestsAt?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof GenericOrderReadAttributes
     */
    segmentationType?: GenericOrderReadAttributesSegmentationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GenericOrderReadAttributes
     */
    shortUuid?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericOrderReadAttributes
     */
    startDate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GenericOrderReadAttributes
     */
    status: GenericOrderReadAttributesStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof GenericOrderReadAttributes
     */
    totalAmount?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GenericOrderReadAttributes
     */
    uuid?: string;
    /**
     * 
     * @type {number}
     * @memberof GenericOrderReadAttributes
     */
    totalGuestRooms?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof GenericOrderReadAttributes
     */
    touristTaxAmount?: Array<string>;
    /**
     * 
     * @type {Array<GenericOrderReadAttributesUnfinishedTasksTypes>}
     * @memberof GenericOrderReadAttributes
     */
    unfinishedTasksTypes?: Array<GenericOrderReadAttributesUnfinishedTasksTypes>;
    /**
     * 
     * @type {string}
     * @memberof GenericOrderReadAttributes
     */
    amountPaid?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum GenericOrderReadAttributesChannelTypeEnum {
    Booking = 'booking',
    BackOffice = 'back-office'
}
/**
    * @export
    * @enum {string}
    */
export enum GenericOrderReadAttributesNextStatusesEnum {
    Blocked = 'blocked',
    Canceled = 'canceled',
    Confirmed = 'confirmed',
    Closed = 'closed',
    DraftBackoffice = 'draft-backoffice',
    Option = 'option',
    Potential = 'potential',
    Tentative = 'tentative',
    Turndown = 'turndown'
}
/**
    * @export
    * @enum {string}
    */
export enum GenericOrderReadAttributesSegmentationTypeEnum {
    CONGRESS = 'CONGRESS',
    GROUPTRAVEL = 'GROUP_TRAVEL',
    INCENTIVES = 'INCENTIVES',
    MEETINGORCONFERENCE = 'MEETING_OR_CONFERENCE',
    SOCIALEVENT = 'SOCIAL_EVENT',
    WEDDING = 'WEDDING'
}
/**
    * @export
    * @enum {string}
    */
export enum GenericOrderReadAttributesStatusEnum {
    Blocked = 'blocked',
    Canceled = 'canceled',
    Confirmed = 'confirmed',
    Closed = 'closed',
    DraftBackoffice = 'draft-backoffice',
    Option = 'option',
    Potential = 'potential',
    Tentative = 'tentative',
    Turndown = 'turndown'
}

